import React from "react";
import AccountSignups from "./components/AccountSignups";
import AccountStatus from "./components/AccountStatus";
import ActiveAccounts from "./components/ActiveAccounts";
import AnnualTaxSubmission from "./components/AnnualTaxSubmission";
import CompletionRate from "./components/CompletionRate";
import CumulativeActiveAccounts from "./components/CumulativeActiveAccounts";
import DailySignups from "./components/DailySignups";
import DashboardNavigation from "./components/DashboardNavigation";
import Financials from "./components/Financials";
import Overview from "./components/Overview";
import Referrals from "./components/Referrals";
import TopCities from "./components/TopCities";

const Home = () => {
  return (
    <div className="mt-2">
      <div className="max-w-7xl mx-auto px-6 lg:px-0">
        <div className="grid grid-cols-2">
          <div className="col-span-2">
            <Financials />
          </div>
        </div>
        <div className="grid grid-cols-2 mt-5">
          <div className="col-span-2">
            <ActiveAccounts />
          </div>
        </div>
        <div className="grid grid-cols-2 mt-5">
          <div className="col-span-2">
            <CumulativeActiveAccounts />
          </div>
        </div>
        <div className="grid grid-cols-8 gap-5 mt-5">
          <div className="col-span-5 space-y-4">
            <TopCities />
            <Overview />
          </div>
          <div className="col-span-3 space-y-4">
            <DailySignups />
            <CompletionRate />
          </div>
        </div>
        <div className="grid grid-cols-8 gap-5 mt-5">
          <div className="col-span-3 space-y-4">
            <AccountStatus />
          </div>
          <div className="col-span-5 space-y-4">
            <AccountSignups />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-5 mt-5">
          <div className="col-span-2">
            <AnnualTaxSubmission />
          </div>
        </div>
        <div className="grid grid-cols-3 mt-5 gap-5">
          <div className="col-span-2">
            <Referrals />
          </div>
          <div className="col-span-1">
            <DashboardNavigation />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
